import { render } from "./Shaking.vue?vue&type=template&id=62e83a68&scoped=true"
import script from "./Shaking.vue?vue&type=script&lang=ts"
export * from "./Shaking.vue?vue&type=script&lang=ts"

import "./Shaking.vue?vue&type=style&index=0&id=62e83a68&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62e83a68"

export default script